import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import { Button } from "@/shared/ui/button";
import { AlertTriangle } from "lucide-react";

interface DeleteContentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  contentType?: string;
  isLoading?: boolean;
}

export const DeleteContentModal = ({
  isOpen,
  onClose,
  onConfirm,
  contentType = "conteúdo",
  isLoading = false,
}: DeleteContentModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px] bg-[#1a1a1a] border-[#333333]">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-500/10">
              <AlertTriangle className="h-5 w-5 text-red-500" />
            </div>
            <div>
              <DialogTitle className="text-white text-lg font-semibold">
                Excluir {contentType}
              </DialogTitle>
              <DialogDescription className="text-white/60 text-sm">
                Esta ação não pode ser desfeita
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        
        <div className="py-4">
          <p className="text-white/80 text-sm leading-relaxed">
            Tem certeza que deseja excluir este{" "}
            <span className="font-semibold text-white">
              {contentType}
            </span>
            ? Esta ação irá remover permanentemente todo o conteúdo e dados relacionados.
          </p>
          
          <div className="mt-4 p-3 bg-red-500/10 border border-red-500/20 rounded-md">
            <p className="text-red-400 text-xs font-medium">
              ⚠️ Esta ação é irreversível e não pode ser desfeita.
            </p>
          </div>
        </div>

        <DialogFooter className="flex gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
            className="bg-transparent border-[#333333] text-white hover:bg-[#222222] hover:text-white/60"
          >
            Cancelar
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-red-600 hover:bg-red-700 text-white border-0"
          >
            {isLoading ? "Excluindo..." : `Sim, Excluir ${contentType}`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
